// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2KK8G","info":"Note_info__1s5qp","note":"Note_note__JvNve","actions":"Note_actions__1s8JE"};